import { useGetDevelopmentsQuery as useGetDevelopmentsTokkoQuery } from '@apis/middlewareTokkoApi/developments'
import { useGetDevelopmentsMiddlewareQuery as useGetDevelopmentsMiddlewareQuery } from '@apis/mediacore/owner'
import { useGetDevelopmentsQuery as useGetDevelopmentsMediacoreQuery } from '@apis/mediacore/emprendimientos'

function useQueryDevelopments(tokkoKey?: string) {
  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'

  const { data, isLoading, isError } = tokkoKey
    ? middlewarev2
      ? useGetDevelopmentsMiddlewareQuery()
      : useGetDevelopmentsTokkoQuery(tokkoKey)
    : useGetDevelopmentsMediacoreQuery({
        CLIENT_ID: process.env.GATSBY_CLIENTID,
        PARAMS: '',
      })

  return { data, isLoading, isError }
}

export default useQueryDevelopments
